<template>
  <div class="kp-modular-section clearfix">
    <label class="kp-modular-label" v-if="jumpList.length > 1">{{$t('edit.sidebar.all_other_cases')}}</label>
    <label class="kp-modular-label" v-else>{{$t('edit.sidebar.always_jump_to')}}</label>
    <step-jump-select :jump="jump" :selected="selected"></step-jump-select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import StepJumpSelect from '../../../../../general/StepJumpSelect.vue';

export default {
  components: {
    StepJumpSelect,
  },
  props: [
    'jump',
    'selected',
  ],
  computed: mapGetters({
    jumpList: 'jumpList',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Exception.vue?cf9c036e
 **/